import { createTheme } from '@mui/material/styles';

export default createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: [
      'acumin-pro',
      '"Franklin Gothic"',
      'sans-serif'
    ].join(','),
  },
  fontFamily: 'acumin-pro, "Franklin Gothic", sans-serif',
  overrides:{
    MuiInput:{
      underline:{
        '&:before':{backgroundColor:'#222222'},
        '&:hover:not($disabled):before':{backgroundColor:'#333333'},
        '&:after':{backgroundColor:"#D79D10"}
      }
    }
  },
  palette: {
    primary:{
      light:'#8E6F3E',
      main:'#8E6F3E',
      dark:'#8E6F3E',
      contrastText:'#fff'
    },
    secondary: {
      light: '#555960',
      main: '#555960',
      dark: '#555960',
      contrastText: '#fff',
    },
    primary1Color: "#555960",
    primary2Color: "#DAAA00",
    accent1Color: "#555960",
    pickerHeaderColor: "#DDB945"
  }
});